var scope_0 = require('/Users/mcruz/Documents/Developer/gatsby/appuro-viaespiga-pt/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16012034ac384e9b3debd9ba7c93d7e9.js').default;
var scope_1 = require('/Users/mcruz/Documents/Developer/gatsby/appuro-viaespiga-pt/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e47c5d131a55f82a7ad03c7491fa7e72.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    